import {
  HttpTransportType,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import * as Constants from "common/helpers/constants";
import reduxSignalRMiddleware, {
  withCallbacks,
} from "common/realtime/redux-signalr-middleware";
import Guid from "common/values/guid/guid";
import MessageAPIResponse from "messaging/entities/message/api/response-contracts/message-api-response";
import Action from "notifications/values/action/action";
import TopicCategory from "notifications/values/topic-category/topic-category";
import Session from "users/session/session";
import { addCommentThread } from "work/entities/comment-thread/store/comment-thread-redux-slice";
import Comment from "work/entities/comment/comment";
import { addComment, removeCommentById } from "work/entities/comment/store/comments-redux-slice";

export const commentsHubConnection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Debug)
  .withUrl(`${Constants.apiBaseUrl}/messageHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () =>
      Session.loadFromStorage(() => { }).authToken?.value ?? "",
  })
  .withAutomaticReconnect()
  .build();

const toMessage = (payload: unknown) =>
  Object.assign(new MessageAPIResponse(), payload as object).deserialize();

const callbacks = withCallbacks()
  .add("message-received", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    if (!(message.forum.topic?.entityClass?.toLowerCase() === TopicCategory.Work.Proposal.toLowerCase() &&
      message.forum.topic.context?.toLowerCase().includes(Action.Review.toLowerCase()))
    ) {
      return;
    }
    const comment = Comment.fromMessage(message);
    dispatch(addComment(comment));
    dispatch(addCommentThread(comment.thread));
  })
  .add("message-updated", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    if (!(message.forum.topic?.entityClass?.toLowerCase() === TopicCategory.Work.Proposal.toLowerCase() &&
      message.forum.topic.context?.toLowerCase().includes(Action.Review.toLowerCase()))
    ) {
      return;
    }
    const comment = Comment.fromMessage(message);
    dispatch(addComment(comment));
    dispatch(addCommentThread(comment.thread));
  })
  .add("message-deleted", (payload: unknown) => (dispatch) => {
    const deletedCommentId = new Guid((payload as { id: string }).id);
    dispatch(removeCommentById(deletedCommentId));
  });

export const commentsSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: commentsHubConnection,
  shouldConnectionStartImmediately: true,
});
